import type { NextPage } from 'next'
import { BlogList, Container, Section } from 'atoms'
import { BlogPageProps, getEntriesByMonth } from 'BlogEntries'
import { Layout, Main } from 'layout'
import { dateFormat } from 'lib/utils'
import Head from 'next/head'
import Link from 'next/link'
import { ContactCard } from 'organisms'
import { useMemo } from 'react'

const BlogMonth: NextPage<BlogPageProps> = ({
  year = '',
  month = '',
}) => {
  const blogEntries = useMemo(
    () => getEntriesByMonth(year, month),
    [month, year]
  )

  return (
    <Layout>
      <Head>
        <title>
          Blog {dateFormat(Number(month), 'MMMM')} {year} | FrauenCoach
        </title>
        <meta name="description" content={`Lebensfragen klären - Krisen meistern ● Ihr Coach ● Kein Risiko, nachhaltig und individuell ● Identität, Beziehungen, Gesundheit, Balance, Selbstbestimmung`} />
      </Head>
      <Main>
        <Section background="rose">
          <Container>
            <h1>
              Blog Beiträge - {dateFormat(Number(month), 'MMMM')} {year}
            </h1>
          </Container>
        </Section>
        <Section>
          <Container>
            <h4>
              <Link href={`/blog/${year || ''}`}>
                {year}
              </Link>
                &nbsp;/&nbsp;
              {month}
            </h4>
            <BlogList blogEntries={blogEntries} />
          </Container>
        </Section>
        <Section background="vintage">
          <Container>
            <ContactCard />
          </Container>
        </Section>
      </Main>
    </Layout>
  )
}

export default BlogMonth
